type Step = {
  id: number;
  label: string;
  description: string;
};

const steps: Step[] = [
  { id: 1, label: 'Trip Details', description: 'Enter trip and travel details' },
  { id: 2, label: 'Customer Details', description: 'Add customer information' },
  { id: 3, label: 'Vehicle & Pricing', description: 'Select vehicle & review price' },
  { id: 4, label: 'Review & Confirm', description: 'Confirm your booking' },
];

export const Stepper = ({ currentStep }: { currentStep: number }) => {
  return (
    <div className="flex w-full max-w-[800px] mx-auto items-start justify-between relative px-[40px]">
      {/* Background Line */}
      <div className="absolute top-[16px] left-[110px] right-[110px] h-[1px] bg-[#E0E0E0] z-0" />

      {steps.map((step) => {
        const isActive = currentStep === step.id;

        return (
          <div key={step.id} className="flex flex-col items-center w-[160px] z-10">
            <div 
              className={`flex items-center justify-center w-[64px] h-[32px] rounded-[16px] text-[14px] font-bold font-host mb-3 transition-colors ${
                isActive ? 'bg-[#FF6A1A] text-[#1A1A1A]' : 'bg-[#E0E0E0] text-[#1A1A1A]'
              }`}
            >
              {step.id}
            </div>
            <span className={`text-[13px] font-bold font-host text-center mb-1 ${isActive ? 'text-[#1A1A1A]' : 'text-[#9E9E9E]'}`}>
              {step.label}
            </span>
            <span className="text-[11px] font-host text-[#BDBDBD] text-center px-2">
              {step.description}
            </span>
          </div>
        );
      })}
    </div>
  );
};
